import VueI18n from "vue-i18n";
import { messages } from "@/messages/messages";

export const generateI18n = function(locale: string) {
  return new VueI18n({
    locale: locale ?? "ja",
    messages
  });
};
